import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { theme, toRem, StyledTextFieldDiv, StyledRadioButtonDiv } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';
import { StyledPopupDiv } from '../../atoms/popup/popup.styles';
import { StyledPopupHeaderDiv } from '../../atoms/popupHeader/popupHeader.styles';
import { StyledPopupMain } from '../../atoms/popupMain/popupMain.styles';
import { HINDI_LANG } from '../../../../../../modules/constants';

export const StyledSpecialRatesDiv = styled.div`
  ${rtl`
  position: relative;
  color: ${theme.color['dark-gray-2']};
  font-weight: ${theme.fonts['fontWeightMedium']};
  font-family: ${theme.fontFamily.swiss} !important;
  .label-text{
    display:flex;
  }
  .spl-rates-radio-container {
    position: relative;
  }
  .adf-special-rates{
    @media ${theme.mediaQuery.desktop}{
      margin-left: ${toRem(-18)};
      padding-top: 0 !important;
    }
    @media ${theme.mediaQuery.allTablets} {
      padding-left:  ${toRem(1)} !important;
    }

  }
  @media ${theme.mediaQuery.mobileOnly} {
    .t-overline-normal{
      margin-left: ${toRem(16)};
    }
    .done-btn{
      width:100%;
    }
    height: calc(100% - 132px);
    overflow-y: auto;
    .icon-cancel:before{
      background: ${theme.color.white};
      border-bottom: ${toRem(2)} solid white;
    }
  }
  &.search-rates {
    min-width: ${toRem(268)};
    min-height: ${toRem(59)};
    margin-right: 0;
    padding: 0;
    ${StyledRadioButtonDiv} {
      border-bottom-color: ${theme.color['light-gray-6']};
    }
    @media ${theme.mediaQuery.allTablets} {
      min-width: 30%;
      padding-left: ${toRem(0)};
      padding-top: ${toRem(10)};
    }
    @media ${theme.mediaQuery.mobileTablet} {
      &.custom-code-apply {
        min-width: 36.5%;
      }
    }
    .close-popup-header {
      background: transparent;
      box-shadow: none;
      padding: 0 0 0 ${toRem(40)};
      z-index: 1 !important;
      @media ${theme.mediaQuery.allTablets} {
        padding-left: ${toRem(24)};
      }
    }
    .open-popup-header {
      margin-top: ${toRem(-5)};
      overflow-y:visible;
      padding: ${toRem(0)} ${toRem(24)} ${toRem(16)} ${toRem(24)} !important;
      @media ${baseVariables.mediaQuery.md} {
        padding-top: ${toRem(10)} !important;
      }
    }
    .open-popup-header:not(.adf-special-rates) {
      max-height: ${toRem(420)} !important;

      }
    ${StyledPopupDiv} {
      padding-top: ${toRem(5)};
      padding-bottom: ${toRem(10)};
      @media ${theme.mediaQuery.allTablets} {
        left: 0;
        top: ${toRem(-3.5)};
      }      
      .corp-code-container {
        min-height: ${toRem(19)};
        span {
          font-size: ${toRem(12)};
        }
        .m-button-secondary {
          min-width: ${toRem(69)};
          text-align: right;
        }
        @media ${theme.mediaQuery.allTablets} {
          span {
            left: ${toRem(36)};
          }
          .m-button-secondary {
            min-width: ${toRem(63)};
            right: 0;
            text-align: right;
          }
        }
      }
    }
    ${StyledPopupHeaderDiv} {
      span {
        &.custom-rates-label {
          letter-spacing: normal;
          padding-top: ${toRem(3)};
          &::first-letter {
            text-transform: capitalize;
          }
        }
      }
    }
    .special-rates-dropdown
    {
      display: flex;
      overflow: hidden;

    button {
      background: none;
      padding: 0;
      white-space: nowrap;
      overflow:hidden;
      text-overflow: ellipsis;
      &:is(${HINDI_LANG}) {
        line-height: ${toRem(26)};
      }
      @media ${theme.mediaQuery.allTablets}{
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 8px;
      }
    }
    .displayEllipisis{
      overflow:hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 8px;
    }
    .icon-dropdown-down {
      font-size: ${toRem(20)};
      line-height: 1;
      cursor: pointer;
      @media ${theme.mediaQuery.desktop}{
      margin-top: ${toRem(4)};
      }
      @media ${theme.mediaQuery.allTablets}{
      padding-top: ${toRem(3)};
      }
    }
  }
  }
  &.adf-rates {
    @media ${theme.mediaQuery.allTablets} {   
    min-width:38%;
  }
  .open-popup-header {
    padding-top:${toRem(16)} !important;
  top:${toRem(-14)};
}
    }
  .search-button {
    color: #1c1c1c;
    font-size: ${toRem(16)};
    line-height: ${toRem(22)};
    font-weight: ${theme.fonts['fontWeightMedium']};
    margin-top: ${toRem(4)};
    &:focus-visible {
      outline: ${toRem(1)} solid ${theme.color['black']};
      }
  }
  .search-form-label {
    font-size: ${toRem(12)};
    font-weight: ${theme.fonts['fontWeightMedium']};
    text-transform: uppercase;
  }
  .crop-promo-code {
    @media ${theme.mediaQuery.mobileOnly} {
      margin-right:${toRem(16)};
    }
    margin-top:${toRem(16)};
    &.search-form-promo-code {
      ${StyledTextFieldDiv} {
        width: 71%;
        max-width: ${toRem(370)};
      }
      .cta-reset {
        &:before {
          color: ${theme.color['black']};
        }
      }
      .m-button-s {
        min-width: ${toRem(85)};
        right: ${toRem(-8)};
        @media ${theme.mediaQuery.allTablets} {
          min-width: ${toRem(75)};
          right: ${toRem(0)};
        }
      }
    }
    position: relative;
    input {
      font-weight: ${theme.fonts['fontWeightMedium']};
    }
    button {
      display: inline-block;
      position: absolute;
      &[class*='m-button'] {
        bottom: ${toRem(8)};
        right: ${toRem(40)};
        @media ${theme.mediaQuery.tablet} {
          right: ${toRem(0)};
        }
      }
    }
  }
  fieldset {
    padding: 0;
    border: none;
    margin: 0;
    legend {
      margin-bottom: 0;
    }
  }

  ${StyledPopupDiv} {
    padding-top: 0;
    @media ${theme.mediaQuery.tablet} {      
      max-height: ${toRem(506)};
      width: ${toRem(386)};    
    }
    @media ${theme.mediaQuery.largeDesktop} {
      width: ${toRem(402)};
    }
  }
  ${StyledTextFieldDiv} {
    margin-top: ${toRem(16)};
    @media ${theme.mediaQuery.mobileOnly} {
      margin-right: ${toRem(20)};
      border-bottom:${toRem(1)} solid ${theme.color['dark-gray-3']};

    }
  }
  ${StyledPopupMain} {
    .radio-label {
      width:inherit;
      border-bottom:${toRem(1)} solid ${theme.color['dark-gray-3']};
    }
    @media ${theme.mediaQuery.mobileOnly} {
      .h-r-label-form-field.spl-rates-heading {
        color: ${theme.color['dark-gray-4']};
        &.label-black {
          color: ${theme.color['cod-grey']};
          font-size: ${toRem(16)};
          line-height: ${toRem(20)};
          letter-spacing: normal;
          text-transform: none;
        }
      }
      @media ${theme.mediaQuery.tablet} {
        max-height: ${toRem(421)};
        padding-bottom: ${toRem(32)};
      }
      input[type=radio]:checked~label:before {
        outline:none !important;
      }
    }
  }
  ${StyledPopupHeaderDiv} {
    span {
      letter-spacing: ${toRem(1.3)};
    }
    .h-r-label-form-field {
      margin: ${toRem(24)} ${toRem(24)} 0 0;
      @media ${theme.mediaQuery.mobileOnly} {
        margin: 0;
      }
    }
  }
  ${StyledRadioButtonDiv} {
    &.radio-label label {
      font-weight: ${theme.fonts['fontWeightRegular']};
    }
    input[type=radio]:checked~label:before {
      outline:none !important;
    }
  }
  [class^='icon-'] {
    color: ${theme.color['dark-gray-1']};
  }
  .cta-reset {
    font-size: ${toRem(17.6)};
    line-height: ${toRem(20)};
    position: absolute;
    bottom: ${toRem(14)};
    right: ${toRem(100)};
    @media ${theme.mediaQuery.mobileOnly} {
      right: ${toRem(20)};
    }
    padding: 0;
    &:before {
      color: ${theme.color['light-gray-6']};
    }
    background:${theme.color['base-20']};
    &:focus {
      outline-offset: 0;
      outline-style: solid;
    }
  }

  .corp-edit-label{
    @media ${baseVariables.mediaQuery.md} {
      width: ${toRem(235)};
    }
  }

  .corp-code-edit {
    position: relative;
    label:first-of-type {
      position: relative;
      top: ${toRem(-7)};
      &:before {
        top: ${toRem(7)};
      }
      &:after {
        top: ${toRem(14)};
      }
    }
  }
  .corp-code-container {
    span {
      position: absolute;
      bottom: ${toRem(15)};
      left: ${toRem(52)};
      @media ${theme.mediaQuery.tablet} {
        bottom: ${toRem(36)};
        left: ${toRem(60)};
      }
      @media ${theme.mediaQuery.desktop} {
        left: ${toRem(36)};
      }
      @media ${theme.mediaQuery.largeDesktop} {
        left: ${toRem(36)};
      }
      font-size: ${toRem(14)};
      line-height: ${toRem(16)};
      color: ${theme.color['dark-gray-4']};
    }
    .cta-link {
      position: absolute;
      bottom: ${toRem(26)};
      right: ${toRem(4)};
      text-align: right;
      @media ${theme.mediaQuery.tablet} {
        bottom: ${toRem(46)};
      }
      color: ${theme.color['black']};
      font-size: ${toRem(13)};
      line-height: ${toRem(16)};
      font-weight: ${theme.fonts['fontWeightMedium']};
      background: none;
      border: none;
      :hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
`}
  .adf-special-rates {
    max-height: ${toRem(420)}!important;
    @media ${baseVariables.mediaQuery.md} {
      max-height: ${toRem(400)} !important;
    }
    @media ${baseVariables.mediaQuery.xl} {
      max-height: ${toRem(420)} !important;
    }
  }
`;
